var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Skeleton',[_c('SkeletonItem',[_c('div',{staticStyle:{"width":"830px","height":"340px","border-radius":"8px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }